/* eslint-disable unicorn/prevent-abbreviations */
import { makeRoute } from '~/utils/route';

import devCardGridTemplate from './card-grid/dev-card-grid.html';
import DevCardGridController from './card-grid/dev-card-grid.controller';
import devCommentsTemplate from '~/pages/dev/comments/dev-comments.html';
import DevCommentsController from '~/pages/dev/comments/dev-comments.controller';
import devDatepickerTemplate from './datepicker/dev-datepicker.html';
import DevDatePickerController from './datepicker/dev-datepicker.controller';
import devDroitTemplate from './droit/dev-droit.html';
import DevDroitController from './droit/dev-droit.controller';
import devGisTemplate from './gis/dev-gis.html';
import DevGisController from './gis/dev-gis.controller';
import devInputCardTemplate from './input-card/dev-input-card.html';
import DevInputCardController from './input-card/dev-input-card.controller';
import devInputGeoTemplate from './input-geo/dev-input-geo.html';
import DevInputGeoController from './input-geo/dev-input-geo.controller';
import devInputMaskTemplate from './input-mask/dev-input-mask.html';
import DevInputMaskController from './input-mask/dev-input-mask.controller';
import devKidTemplate from './kid/dev-kid.html';
import DevKidController from './kid/dev-kid.controller';
import devKpathTemplate from './kpath/dev-kpath.html';
import DevKpathController from './kpath/dev-kpath.controller';
import devKtableTemplate from './ktable/dev-ktable.html';
import DevKtableController from './ktable/dev-ktable.controller';
import devMfTemplate from './mf/dev-mf.html';
import DevMfController from './mf/dev-mf.controller';
import devMailFormHeaderTemplate from './mail-form-header/dev-mail-form-header.html';
import DevMailFormHeaderController from './mail-form-header/dev-mail-form-header.controller';
import devPhoneNumberTemplate from './phone-number/dev-phone-number.html';
import DevPhoneNumberController from './phone-number/dev-phone-number.controller';
import devPostalAddressTemplate from './postal-address/dev-postal-address.html';
import DevPostalAddressController from './postal-address/dev-postal-address.controller';
import devQrCodeGeneratorTemplate from './qr-code-generator/dev-qr-code-generator.html';
import DevQrCodeGeneratorController from './qr-code-generator/dev-qr-code-generator.controller';
import devRepreTemplate from './repre/dev-repre.html';
import DevRepreController from './repre/dev-repre.controller';
import devSmartFieldTemplate from './smart-field/dev-smart-field.html';
import DevSmartFieldController from './smart-field/dev-smart-field.controller';
import devTextEditorTemplate from './text-editor/dev-text-editor.html';
import DevTextEditorController from './text-editor/dev-text-editor.controller';
import ChunkedDownloadController from './chunked-download/chunked-download.controller';
import chunkedDownload from './chunked-download/chunked-download.html';
import devCodeEditorTemplate from './code-editor/dev-code-editor.html';
import DevCodeEditorController from './code-editor/dev-code-editor.controller';
import devJSONEditorTemplate from './json-editor/dev-json-editor.html';
import DevJSONEditorController from './json-editor/dev-json-editor.controller';

export default [
	makeRoute({
		template:   devCardGridTemplate,
		controller: DevCardGridController,
		title:      'dev card-grid',
		path:       '/dev/card-grid',
		onlyDev:    true,
	}),
	makeRoute({
		template:   devCommentsTemplate,
		controller: DevCommentsController,
		title:      'dev comments',
		path:       '/dev/comments',
		onlyDev:    true,
	}),
	makeRoute({
		template:   devDatepickerTemplate,
		controller: DevDatePickerController,
		title:      'dev datepicker',
		path:       '/dev/datepicker',
		onlyDev:    true,
	}),
	makeRoute({
		template:     devDroitTemplate,
		controller:   DevDroitController,
		title:        'dev droit',
		path:         '/dev/droit',
		onlyDev:      true,
	}),
	makeRoute({
		template:     devGisTemplate,
		controller:   DevGisController,
		title:        'dev GIS',
		path:         '/dev/gis',
		onlyDev:      true,
	}),
	makeRoute({
		template:     devInputCardTemplate,
		controller:   DevInputCardController,
		title:        'dev input-card',
		path:         '/dev/input-card',
		onlyDev:      true,
	}),
	makeRoute({
		template:     devInputGeoTemplate,
		controller:   DevInputGeoController,
		title:        'dev input-geo',
		path:         '/dev/input-geo',
		onlyDev:      true,
	}),
	makeRoute({
		template:   devInputMaskTemplate,
		controller: DevInputMaskController,
		title:      'dev input-mask',
		path:       '/dev/input-mask',
		onlyDev:    true,
	}),
	makeRoute({
		template:     devKidTemplate,
		controller:   DevKidController,
		title:        'dev kid',
		path:         '/dev/kid',
		onlyDev:      true,
	}),
	makeRoute({
		template:     devKpathTemplate,
		controller:   DevKpathController,
		title:        'dev kpath',
		path:         '/dev/kpath',
		onlyDev:      true,
	}),
	makeRoute({
		template:     devKtableTemplate,
		controller:   DevKtableController,
		title:        'dev ktable',
		path:         '/dev/ktable',
		onlyDev:      true,
	}),
	makeRoute({
		template:     devMfTemplate,
		controller:   DevMfController,
		title:        'dev mf',
		path:         '/dev/mf',
		onlyDev:      true,
	}),
	makeRoute({
		template:     devMailFormHeaderTemplate,
		controller:   DevMailFormHeaderController,
		title:        'dev mail-form-header',
		path:         '/dev/mail-form-header',
		onlyDev:      true,
	}),
	makeRoute({
		template:     devPostalAddressTemplate,
		controller:   DevPostalAddressController,
		title:        'dev postal-address',
		path:         '/dev/postal-address',
		onlyDev:      true,
	}),
	makeRoute({
		template:     devPhoneNumberTemplate,
		controller:   DevPhoneNumberController,
		title:        'dev phone-number',
		path:         '/dev/phone-number',
		onlyDev:      true,
	}),
	makeRoute({
		template:     devQrCodeGeneratorTemplate,
		controller:   DevQrCodeGeneratorController,
		title:        'dev qr-code-generator',
		path:         '/dev/qr-code-generator',
		onlyDev:      true,
	}),
	makeRoute({
		template:     devRepreTemplate,
		controller:   DevRepreController,
		title:        'dev repre',
		path:         '/dev/repre',
		onlyDev:      true,
	}),
	makeRoute({
		template:     devSmartFieldTemplate,
		controller:   DevSmartFieldController,
		title:        'dev smart-field',
		path:         '/dev/smart-field',
		onlyDev:      true,
	}),
	makeRoute({
		template:     devTextEditorTemplate,
		controller:   DevTextEditorController,
		title:        'dev text-editor',
		path:         '/dev/text-editor',
		onlyDev:      true,
	}),
	makeRoute({
		template:     chunkedDownload,
		controller:   ChunkedDownloadController,
		title:        'dev chunked download',
		path:         '/dev/chunked-download',
		onlyDev:      true,
	}),
	makeRoute({
		template:     devCodeEditorTemplate,
		controller:   DevCodeEditorController,
		title:        'dev code editor',
		path:         '/dev/code-editor',
		onlyDev:      true,
	}),
	makeRoute({
		template:     devJSONEditorTemplate,
		controller:   DevJSONEditorController,
		title:        'dev json editor',
		path:         '/dev/json-editor',
		onlyDev:      true,
	}),
];
